import {Component, OnInit} from '@angular/core';
import {tabs} from '../../data/static/SelfEnrolTabs';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import * as customValidator from '../../validators/edit-user-validator';
import * as addressValidator from '../../validators/contact-address-validator';
import * as bankValidator from '../../validators/cardholder-validator';
import {NgbCalendar, NgbDate, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import {FormUtils} from 'src/app/FormUtils';
import {Router} from '@angular/router';
import {Ship} from '../../Ship';
import {ShipService} from '../../services/ship.service';
import {SelfEnrollService} from 'src/app/services/self-enroll.service';
import {MessageService} from 'src/app/services/message.service';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import {AuthService} from '../../services/auth.service';
import {countryCodes} from '../../country-codes';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css'],
  providers: [NgbDatepickerConfig]
})
export class InformationComponent implements OnInit {
  tabs = [];
  user: object;
  auth = false;
  personalForm: UntypedFormGroup;
  selectedLocation = '';
  bankForm: UntypedFormGroup;
  locations: any[];
  meus: any[];
  processing = false;
  countries = countryCodes;
  acctTypes = ['Checking', 'Savings'];
  meuData: { [key: string]: string[] } = {
    MLG001: ['11','13','15'],
    MLG002: ['22','24','26'],
    MLG003: ['31']
  }
  applicableMeus: any[];
  ranks = [
    'E1',
    'E2',
    'E3',
    'E4',
    'E5',
    'E6',
    'E7',
    'E8',
    'E9',
    'O1',
    'O2',
    'O3',
    'O4',
    'O5',
    'O6',
    'O7',
    'O8',
    'O9',
    'O10',
    'O11',
    'W2',
    'W3',
    'W4',
    'W5',
    'CIV'
  ];
  branchs = ['Air Force', 'Army', 'Coast Guard', 'Marines', 'Navy'];
  states = [
    'AA',
    'AE',
    'AK',
    'AL',
    'AP',
    'AR',
    'AS',
    'AZ',
    'CA',
    'CN',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'GU',
    'GX',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MH',
    'MI',
    'MN',
    'MO',
    'MP',
    'MS',
    'MT',
    'MX',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UK',
    'UT',
    'VA',
    'VI',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY'
  ];
  importedCAIAFields = [
    'firstName',
    'middleInitial',
    'lastName',
    'ssn',
    'phone',
    'permAddressLine1',
    'permCity',
    'permState',
    'permZip',
  ];
  email: string;
  timestamp: number;
  today: NgbDate;
  check = false;
  isCampSelected = false;

  constructor(
    private formUtils: FormUtils,
    private store: Store<fromApp.AppState>,
    private router: Router,
    private shipService: ShipService,
    private selfEnrollService: SelfEnrollService,
    private messageService: MessageService,
    private calendar: NgbCalendar,
    private config: NgbDatepickerConfig,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.store.select('SelfEnroll').subscribe((store) => {
      this.email = store.email;
      this.timestamp = store.emailTimestamp;
      if (this.email === '') {
        this.router.navigate(['/selfEnroll/serviceAndTerms']);
      }
    });
    this.tabs = tabs;
    this.initForm();
    this.shipService.getShipsCommon().subscribe((data: Ship[]) => {
      this.locations = data;
    });
    this.config.minDate = {year: 1900, month: 1, day: 1};
    this.config.maxDate = this.calendar.getToday();
    this.config.outsideDays = 'hidden';
    this.loadUserData();

    this.personalForm.get('location').valueChanges.subscribe(val => {
      if(val.toUpperCase().includes('MLG')) {
        this.isCampSelected = true;
          this.personalForm.get('branch').valueChanges.subscribe(value => {
            if(value == 'Marines'){
              this.applicableMeus = ['Please Select...', ...this.meuData[val]];
              this.personalForm.controls['meu'].setValidators([
                Validators.required,
                Validators.maxLength(2),
                Validators.minLength(2),
                customValidator.meu
              ]);
            }
          });
        if(this.personalForm.get('branch').value == 'Marines'){
          this.applicableMeus = ['Please Select...', ...this.meuData[val]];
          this.personalForm.controls['meu'].setValidators([
          Validators.required,
          Validators.maxLength(2),
          Validators.minLength(2),
          customValidator.meu
        ]);
        }
      } else {
        this.isCampSelected = false;
        this.personalForm.get('meu').setValue('');
        this.personalForm.controls['meu'].clearValidators();
      }
      this.personalForm.controls['meu'].updateValueAndValidity();
    });

  }

  initForm() {
    const authUser = this.authService.getUser();

    this.personalForm = new UntypedFormGroup({
      title: new UntypedFormControl('', [bankValidator.formNameValidator]),
      firstName: new UntypedFormControl('', [
        Validators.required,
        Validators.maxLength(30),
        bankValidator.formNameValidator
      ]),
      middleInitial: new UntypedFormControl('', [bankValidator.middleNameValidator]),
      lastName: new UntypedFormControl('', [
        Validators.required,
        Validators.maxLength(30),
        bankValidator.formNameValidator
      ]),
      payGrade: new UntypedFormControl('', [Validators.required]),
      branch: new UntypedFormControl('', [Validators.required]),
      ssn: new UntypedFormControl('', [
        Validators.maxLength(9),
        Validators.minLength(9),
        Validators.required,
        customValidator.socSecurity
      ]),
      dob: new UntypedFormControl('', [Validators.required]),
      maiden: new UntypedFormControl('', [
        Validators.required,
        Validators.maxLength(30),
        bankValidator.formNameValidator
      ]),
      company: new UntypedFormControl('', [Validators.maxLength(30)]),
      meu: new UntypedFormControl(''),
      addressLine1: new UntypedFormControl(''),
      addressLine2: new UntypedFormControl(''),
      addressLine3: new UntypedFormControl(''),
      city: new UntypedFormControl(''),
      state: new UntypedFormControl(''),
      zip: new UntypedFormControl(''),
      country: new UntypedFormControl(''),
      permAddressLine1: new UntypedFormControl('', [
        Validators.maxLength(34),
        Validators.required
      ]),
      permAddressLine2: new UntypedFormControl('', [Validators.maxLength(34)]),
      permAddressLine3: new UntypedFormControl('', [Validators.maxLength(34)]),
      permCity: new UntypedFormControl('', [
        Validators.maxLength(34),
        Validators.required,
        addressValidator.cityValidator
      ]),
      permState: new UntypedFormControl('', [Validators.required]),
      permZip: new UntypedFormControl('', [
        Validators.maxLength(10),
        Validators.required,
        addressValidator.zipValidator
      ]),
      permCountry: new UntypedFormControl(authUser.country, [Validators.required]),
      phone: new UntypedFormControl('', [
        Validators.maxLength(14),
        customValidator.phone,
        Validators.required
      ]),
      location: new UntypedFormControl('', [Validators.required])
    });

    this.bankForm = new UntypedFormGroup({
      bankName: new UntypedFormControl('', [
        bankValidator.formNameValidator,
        Validators.maxLength(30)
      ]),
      acctName: new UntypedFormControl('', [bankValidator.formNameValidator]),
      routing: new UntypedFormControl('', [
        bankValidator.routingNumberValidator,
        Validators.maxLength(9)
      ]),
      acctNumber: new UntypedFormControl('', [
        bankValidator.srcAcctNumValidator,
        Validators.maxLength(16)
      ]),
      confirmAcctNumber: new UntypedFormControl(''),
      acctType: new UntypedFormControl('')
    });
    this.onChanges();
  }

  onChanges() {
    this.bankForm.get('confirmAcctNumber').valueChanges.subscribe(() => {
      this.bankForm.controls['confirmAcctNumber'].markAsTouched();
      this.bankForm.controls['confirmAcctNumber'].setValidators(
        customValidator.accountMustMatch(this.bankForm.get('acctNumber').value)
      );
    });

    this.personalForm.get('company').valueChanges.subscribe((val) => {
      if (val) {
        this.personalForm.controls['permAddressLine3'].disable();
        (<UntypedFormGroup>this.personalForm).patchValue(
          {permAddressLine3: 'C/O:' + val},
          {onlySelf: true}
        );
      } else {
        this.personalForm.controls['permAddressLine3'].enable();
        (<UntypedFormGroup>this.personalForm).patchValue(
          {permAddressLine3: ''},
          {onlySelf: true}
        );
      }
    });
  }

  get contactZipErrorMessage(): string {
    return addressValidator.zipValidatorMessage();
  }

  get contactCityErrorMessage(): string {
    return addressValidator.cityValidatorMessage();
  }

  checkOptions() {
    if (
      this.bankForm.get('bankName').value !== '' ||
      this.bankForm.get('acctName').value !== '' ||
      this.bankForm.get('routing').value !== '' ||
      this.bankForm.get('acctNumber').value !== '' ||
      this.bankForm.get('confirmAcctNumber').value !== '' ||
      (this.bankForm.get('acctType').value !== '' &&
        this.bankForm.get('acctType').value !== 'Please Select...')
    ) {
      this.bankForm.controls['bankName'].setValidators([
        Validators.required,
        bankValidator.formAddressValidator,
        Validators.maxLength(30)
      ]);
      this.bankForm.controls['bankName'].updateValueAndValidity();
      this.bankForm.controls['acctName'].setValidators([
        Validators.required,
        bankValidator.formAddressValidator
      ]);
      this.bankForm.controls['acctName'].updateValueAndValidity();
      this.bankForm.controls['routing'].setValidators([
        Validators.required,
        bankValidator.routingNumberValidator,
        Validators.maxLength(9)
      ]);
      this.bankForm.controls['routing'].updateValueAndValidity();
      this.bankForm.controls['acctNumber'].setValidators([
        Validators.required,
        bankValidator.srcAcctNumValidator,
        Validators.maxLength(16)
      ]);
      this.bankForm.controls['acctNumber'].updateValueAndValidity();
      this.bankForm.controls['confirmAcctNumber'].setValidators([
        Validators.required,
        customValidator.accountMustMatch(this.bankForm.get('acctNumber').value)
      ]);
      this.bankForm.controls['confirmAcctNumber'].updateValueAndValidity();
      this.bankForm.controls['acctType'].setValidators([Validators.required]);
      this.bankForm.controls['acctType'].updateValueAndValidity();
    } else {
      this.clearBankValidation('bankName');
      this.clearBankValidation('acctName');
      this.clearBankValidation('routing');
      this.clearBankValidation('acctNumber');
      this.clearBankValidation('confirmAcctNumber');
      this.clearBankValidation('acctType');
    }

    if (
      this.personalForm.get('addressLine1').value !== '' ||
      this.personalForm.get('city').value !== '' ||
      this.personalForm.get('state').value !== '' ||
      this.personalForm.get('zip').value !== '' ||
      this.personalForm.get('country').value !== ''
    ) {
      this.personalForm.controls['addressLine1'].setValidators([
        Validators.required,
        Validators.maxLength(34)
      ]);
      this.personalForm.controls['addressLine1'].updateValueAndValidity();
      this.personalForm.controls['addressLine2'].setValidators([
        Validators.maxLength(34)
      ]);
      this.personalForm.controls['addressLine2'].updateValueAndValidity();
      this.personalForm.controls['addressLine3'].setValidators([
        Validators.maxLength(34)
      ]);
      this.personalForm.controls['addressLine3'].updateValueAndValidity();
      this.personalForm.controls['city'].setValidators([
        Validators.required,
        Validators.maxLength(34),
        addressValidator.cityValidator
      ]);
      this.personalForm.controls['city'].updateValueAndValidity();
      this.personalForm.controls['state'].setValidators([Validators.required]);
      this.personalForm.controls['state'].updateValueAndValidity();
      this.personalForm.controls['zip'].setValidators([
        Validators.required,
        Validators.maxLength(10),
        addressValidator.zipValidator
      ]);
      this.personalForm.controls['zip'].updateValueAndValidity();
    } else {
      this.clearPersonalValidation('addressLine1');
      this.clearPersonalValidation('addressLine2');
      this.clearPersonalValidation('addressLine3');
      this.clearPersonalValidation('city');
      this.clearPersonalValidation('state');
      this.clearPersonalValidation('zip');
      this.clearPersonalValidation('country');
    }
  }

  clearPersonalValidation(field: string) {
    this.personalForm.controls[field].clearValidators();
    this.personalForm.controls[field].updateValueAndValidity();
  }

  clearBankValidation(field: string) {
    this.bankForm.controls[field].clearValidators();
    this.bankForm.controls[field].updateValueAndValidity();
  }

  changeDate(newDate) {
    let date: any;
    if (newDate.srcElement) {
      const tempDate = new Date(newDate.srcElement.value);
      date = new NgbDate(
        tempDate.getFullYear(),
        tempDate.getMonth() + 1,
        tempDate.getDate()
      );
    } else {
      date = newDate;
    }
    (<UntypedFormGroup>this.personalForm).patchValue(
      {dob: date},
      {onlySelf: true}
    );
  }

  next() {
    this.check = false;
    this.processing = true;
    this.checkOptions();
    this.formUtils.markFormFieldsAsTouched(this.personalForm);
    if (!this.personalForm.valid) {
      this.messageService.error(
        'Please complete required fields highlighted in red'
      );
      this.scrollToTop();
      this.processing = false;
      return false;
    }
    this.formUtils.markFormFieldsAsTouched(this.bankForm);
    if (!this.bankForm.valid) {
      this.messageService.error(
        'Please complete required fields highlighted in red'
      );
      this.scrollToTop();
      this.processing = false;
      return false;
    }
    if (this.auth === false) {
      this.messageService.error(
        'Please complete required fields highlighted in red'
      );
      this.check = true;
      this.processing = false;
      return false;
    }

    this.setUser();

    this.selfEnrollService.preEnroll(this.user).subscribe(
      () => {
        this.router.navigate(['/selfEnroll/verifyEmail']);
      },
      (error) => {
        if (error.error === 'duplicateError') {
          this.messageService.error(
            'The account already exists, please contact CSU or Disbursing'
          );
        } else if (error.status === 200) {
          this.router.navigate(['/selfEnroll/verifyEmail']);
        } else {
          this.messageService.error(error.error);
        }
      },
      () => {
        this.processing = false;
      }
    );
  }

  loadUserData() {
    const authUser = this.authService.getUser();

    this.personalForm.get('firstName').setValue(authUser.firstName);
    this.personalForm.get('middleInitial').setValue(authUser.middleInitial);
    this.personalForm.get('lastName').setValue(authUser.lastName);
    this.personalForm.get('ssn').setValue(authUser.socialSecurity);
    // Default country to the USA if not present
    if(authUser.country === undefined || authUser.country === '') {
      authUser.country = 'USA';
    };

    // DOB format from CAIA: 'YYYY-MM-DD' (i.e. 1975-07-23)
    const parseDate = authUser.dob.split('-', 3);

    const dobNgbDAte = new NgbDate(
      Number(parseDate[0]),
      Number(parseDate[1]),
      Number(parseDate[2])
    );

    this.personalForm.get('dob').setValue(dobNgbDAte);
    this.personalForm.get('maiden').setValue(authUser.mothersMaidenName);
    this.personalForm.get('phone').setValue(authUser.phone);
    this.personalForm.get('permAddressLine1').setValue(authUser.addressLine1);
    this.personalForm.get('permAddressLine2').setValue(authUser.addressLine2);
    this.personalForm.get('permAddressLine3').setValue(authUser.addressLine3);
    this.personalForm.get('permCity').setValue(authUser.city);
    this.personalForm.get('permState').setValue(authUser.state, {onlySelf: true});
    this.personalForm.get('permZip').setValue(authUser.zip);
    this.personalForm.get('permCountry').setValue(authUser.country, {onlySelf: true});

    for(let i : number = 0; i < this.importedCAIAFields.length; i++) {
      if(this.personalForm.get(this.importedCAIAFields[i]).value) {
        this.personalForm.get(this.importedCAIAFields[i]).disable();
      }
    }

    // No Dob being passed has to be handled differently due to NgbDate picker
    const emptyNgbDate = new NgbDate(
      Number(0),
      null,
      null
    );

    if(JSON.stringify(this.personalForm.get('dob').value) === JSON.stringify(emptyNgbDate)) {
      this.personalForm.get('dob').enable();
    } else {
      this.personalForm.get('dob').disable();
    }
  }

  setUser() {
    const input = this.personalForm.get('dob').value;
    const zeroPad = input.day < 10 ? '0' : '';
    const date = input.month + '/' + zeroPad + input.day + '/' + input.year;
    const user = {
      email_addr: this.email.trim(),
      timestamp: this.timestamp,
      salutation: this.personalForm.get('title').value.trim(),
      firstName: this.personalForm.get('firstName').value.trim(),
      middleName: this.personalForm.get('middleInitial').value.trim(),
      lastName: this.personalForm.get('lastName').value.trim(),
      payGrade: this.personalForm.get('payGrade').value.trim(),
      militaryBranch: this.personalForm.get('branch').value.trim(),
      ssn: this.personalForm.get('ssn').value.trim(),
      dob: date.trim(),
      meu: this.personalForm.get('meu').value.trim(),
      mothersMName: this.personalForm.get('maiden').value.trim(),
      phone: this.personalForm.get('phone').value.trim(),
      location: this.personalForm.get('location').value.trim(),
      homeAddr1: this.personalForm.get('permAddressLine1').value.trim(),
      homeAddr2: this.personalForm.get('permAddressLine2').value.trim(),
      homeAddr3: this.personalForm.get('permAddressLine3').value.trim(),
      homeCity: this.personalForm.get('permCity').value.trim(),
      homeState: this.personalForm.get('permState').value.trim(),
      homeZip: this.personalForm.get('permZip').value.trim(),
      homeCountry: this.personalForm.get('permCountry').value.trim(),
      dutyAddressLine1: this.personalForm.get('addressLine1').value.trim(),
      dutyAddressLine2: this.personalForm.get('addressLine2').value.trim(),
      dutyAddressLine3: this.personalForm.get('addressLine3').value.trim(),
      dutyCity: this.personalForm.get('city').value.trim(),
      dutyState: this.personalForm.get('state').value.trim(),
      dutyZip: this.personalForm.get('zip').value.trim(),
      dutyCountry: this.personalForm.get('country').value.trim(),
      bankName: this.bankForm.get('bankName').value.trim(),
      bankAcctName: this.bankForm.get('acctName').value.trim(),
      bankABA: this.bankForm.get('routing').value.trim(),
      bankAcctNum: this.bankForm.get('acctNumber').value.trim(),
      bankAcctType: this.bankForm.get('acctType').value.trim(),
      authorization: this.auth
    };

    this.user = user;
  }

  scrollToTop() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  get dobErrorMessage(): string {
    // Get the first error message from the DOB controller
    const errorCode = Object.keys(this.personalForm.get('dob').errors)[0];
    return bankValidator.dobValidationErrorMessage(errorCode);
  }

}
